import {StaticPasteSpecial} from '@components/editElements/pasteSpecial/StaticPasteSpecialDefinition';

export function isStaticPasteSpecial(value: string) {
  return Object.values(StaticPasteSpecial).includes(value as StaticPasteSpecial);
}
